import Timeline from './components/Timeline';
import React from 'react';
import FormDetalhe from './components/Form/Form';
import { BusinessDetailProvider } from '@/context/BusinessDetailContext';
import { ProductWithBusinessProvider } from './components/Form/ProductWithBusinessContext';
import { TaskProvider } from '@/context/TaskContext';
import pkg from '../../../package.json';


const DetailPage = () => {
  
  const appVersion = pkg.version;
  return (<div className='h-[100%] bg-indigo-200  flex align-center justify-center items-center '>
    <BusinessDetailProvider>  
      <div >
        <div className='grid w-[100%] h-[70%] overflow-hidden '>
          {/** Timeline */}
          <div className='flex bg-indigo-200 w-[100%] border-t-2 h-screen items-start justify-center border-indigo-200'>
          <ProductWithBusinessProvider>
              <FormDetalhe />
            </ProductWithBusinessProvider>
          </div>
        </div>
      </div>
    </BusinessDetailProvider>
    </div>
  );
};

export default DetailPage;
